import React from "react";

export function GenreChip({ active, onClick, children, testid }) {
  return (
    <button type="button" onClick={onClick} data-testid={testid}
      className={`px-4 py-1.5 rounded-full font-mono text-xs uppercase tracking-widest border transition-colors ${
        active ? "bg-red-600 border-red-600 text-white" : "border-white/15 text-white/60 hover:text-white hover:border-white/40"
      }`}>
      {children}
    </button>
  );
}
